var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuVisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    xmlSpace: "preserve",
    id: "calendar2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar2-bezier",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 2,5.6 C 2,4.06 3.2,2.8 4.67,2.8 L 23.33,2.8 23.33,2.8 C 24.81,2.8 26,4.05 26,5.6 L 26,25.2 26,25.2 C 26,26.75 24.81,28 23.33,28 L 4.67,28 4.67,28 C 3.19,28 2,26.75 2,25.2 L 2,5.6 Z M 4,5 L 4,26 24,26 24,5 4,5 Z M 7.33,-0 L 10,-0 10,2.8 7.33,2.8 7.33,-0 Z M 18,-0 L 20.67,-0 20.67,2.8 18,2.8 18,-0 Z M 7.33,12.6 L 10,12.6 10,15.4 7.33,15.4 7.33,12.6 Z M 7.33,18.2 L 10,18.2 10,21 7.33,21 7.33,18.2 Z M 12.67,12.6 L 15.33,12.6 15.33,15.4 12.67,15.4 12.67,12.6 Z M 12.67,18.2 L 15.33,18.2 15.33,21 12.67,21 12.67,18.2 Z M 18,12.6 L 20.67,12.6 20.67,15.4 18,15.4 18,12.6 Z M 18,18.2 L 20.67,18.2 20.67,21 18,21 18,18.2 Z M 18,18.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVisits);
export default __webpack_public_path__ + "static/media/menu_visits.92fb5ac5d8d7859a1331e765638747ec.svg";
export { ForwardRef as ReactComponent };